import React from "react";
import ReactDOM from "react-dom";
import HexModal from "../../../../app/components/modals/HexModal";
import { showErrorMessage } from "../../../commons/show-error-message";
import RemoveSubsidyRecurrentModal from "../../../../app/components/modals/subsidy/RemoveSubsidyRecurrentModal";
import { logError, addContextLog } from "../../../../infrastructure/log";
import { translate } from "../../../../infrastructure/translate/localization";

function renderRemoveSubsidyRecurrentModal(benefit) {
  ReactDOM.render(
    <HexModal>
      <RemoveSubsidyRecurrentModal modelBenefit={benefit} />
    </HexModal>,
    document.getElementById("modal-container")
  );
}

export async function displayRemoveSubsidyRecurrent(benefit) {
  try {
    renderRemoveSubsidyRecurrentModal(benefit);
    addContextLog("info", "displayRemoveSubsidyRecurrent", "display-screen", {
      benefit,
    });
  } catch (e) {
    logError(e, `Error to displayRemoveSubsidyRecurrent in benefit ${benefit}`);
    showErrorMessage(translate("common-messages.basic-error-message"), true);
  }
}
